import styles from './Placeholder.module.css';

interface Props {
  title: string;
  subtitle?: string;
}

export const PlaceholderPage = ({ title, subtitle = 'Будет реализовано на следующих шагах' }: Props) => {
  return (
    <div className={styles.page}>
      <div className={styles.center}>
        <p className={styles.label}>В РАЗРАБОТКЕ</p>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};
